import { PipeTransform } from '@angular/core';
var ReplacePipe = /** @class */ (function () {
    function ReplacePipe() {
    }
    ReplacePipe.prototype.transform = function (value, pattern, replacement) {
        if (value && typeof value === 'string') {
            return value.split(pattern).join(replacement);
        }
        else {
            return value;
        }
    };
    return ReplacePipe;
}());
export { ReplacePipe };
